import React from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useMoveToFolderData } from '../core/FileToFolderAuth'
export default function DataRoomFileView() {
  const location = useLocation()
  const { formatMessage } = useIntl()
  const { contentName } = useMoveToFolderData()
  return (
    <div className='data-room-file-view-wrapper'>
      {' '}
      <div className='Page_ToolBar-wrapper d-md-flex flex-row align-items-center justify-content-between'>
        <div className='Page_ToolBar-left'>
          <h4 className='mb-2 dark_text_color'>Data Room File Detail</h4>
          <ul className='breadcrumb breadcrumb-line text-muted fs-6 fw-bold'>
            <li className='breadcrumb-item pe-1'>
              <Link to={`/`} className='pe-1 item_link'>
                {formatMessage({ id: 'Home' })}
              </Link>
              {'-'}
              <Link to={`/data-rooms/files`} className='px-1 item_link'>
                {formatMessage({ id: 'Files' })}
              </Link>
            </li>
            <li className='breadcrumb-item text-muted'>{contentName}</li>
          </ul>
        </div>
        <div className='Page_ToolBar-right d-flex flex-row align-items-center justify-content-md-end justify-content-between'></div>
      </div>
      <div className='file-view-toolbar-wrapper d-flex flex-xl-row flex-column align-items-xl-end justify-content-between border-bottom border-muted'>
        <div className='file-view-toolbar-left'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5  flex-nowrap '>
            <li className='nav-item mobile-tab font-size-13'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname.includes('main-file-view') && 'active')
                }
                to='/data-rooms/file-view/main-file-view'
              >
                {formatMessage({ id: 'Files' })}
              </Link>
            </li>
            {/* <li className='nav-item mobile-tab font-size-13'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname.includes('e-signature-file-view') && 'active')
                }
                to='/data-rooms/file-view/e-signature-file-view'
              >
                {formatMessage({id: 'E-signatures'})}
              </Link>
            </li> */}
            {/* <li className='nav-item mobile-tab font-size-13'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname.includes('trash-file-view') && 'active')
                }
                to='/data-rooms/file-view/trash-file-view'
              >
                {formatMessage({id: 'Trash'})}
              </Link>
            </li> */}
          </ul>
        </div>
        <div className='file-view-toolbar-right d-flex align-items-center justify-content-end'>
          {/* <button className='btn btn-bg-white margin_right-8px file-filter-icon  font-size-12 font-weight-500  height-36 d-flex align-items-center justify-content-center '>
            <img src={FilterIcon} alt='' className='me-md-2'></img>
            <span className='d-md-block d-none'>{formatMessage({id: 'Filter'})}</span>
          </button> */}
          {/* <div className='all-data-rooms-searchBar d-flex align-content-center bg-white flex-grow-1'>
            <KTSVG
              path='/media/icons/duotune/general/gen021.svg'
              className='svg-icon-3 position-absolute '
            />
            <input
              type='text'
              className='bg-body form-control form-control-flush  font-size-13 font-weight-400  '
              name='search'
              placeholder='Search Documents'
              data-kt-search-element='input'
            />
          </div> */}
          {/* <div className='more-option bg-white margin_right-8px'>
            <img src={addFileIcon} alt=''></img>
          // </div> */}
          {/* // <button className='btn btn-bg-primary margin_right-8px flex-nowrap font-size-13 text-white font-weight-400 height-36 d-flex align-items-center justify-content-center flex-grow-1 '>
          //   {formatMessage({id: 'Upload Files'})}
          // </button> */}
          {/* <div className='more-option bg-white'>
            <img src={moreOptionsIcon} alt=''></img>
          </div> */}
        </div>
      </div>
      <Outlet />
    </div>
  )
}
